// In src/PointsReview.js

import React, { useState, useEffect } from 'react';
import { db, auth } from './firebase';
import { collection, query, where, onSnapshot, doc, updateDoc } from "firebase/firestore";
import { FaCheck, FaTimes, FaSpinner } from 'react-icons/fa';

function PointsReview() {
  const [flaggedEvents, setFlaggedEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processingId, setProcessingId] = useState(null);

  useEffect(() => {
    const q = query(collection(db, "pendingEvents"), where("status", "==", "review_required"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const events = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setFlaggedEvents(events);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleDecision = async (eventId, newStatus) => {
    if (!window.confirm(`Are you sure you want to ${newStatus === 'approved' ? 'APPROVE' : 'REJECT'} this event?`)) return;
    setProcessingId(eventId);
    try {
      const eventRef = doc(db, "pendingEvents", eventId);
      await updateDoc(eventRef, {
        status: newStatus,
        reviewedBy: auth.currentUser.email, // Log who made the decision
        reviewedAt: new Date(),
      });
      alert(`Event successfully ${newStatus}!`);
    } catch (error) {
      console.error("Error updating event status:", error);
      alert("Failed to update event status.");
    } finally {
      setProcessingId(null);
    }
  };

  if (loading) return <p className="loading-text">Loading flagged events...</p>;

  return (
    <div className="card">
      <h2 className="page-header">Manual Points Review</h2>
      <p className="page-subheader">These events were flagged by the automated system and require your approval.</p>

      {flaggedEvents.length === 0 ? (
        <p>No events are currently waiting for manual review. Great job!</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Driver ID</th>
              <th>Event Type</th>
              <th>Reason for Flag</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {flaggedEvents.map(event => (
              <tr key={event.id}>
                <td title={event.driverId}>{event.driverId.substring(0, 8)}...</td>
                <td>{event.eventType}</td>
                <td>{event.reviewReason}</td>
                <td>{event.createdAt?.toDate().toLocaleString()}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="btn btn-decline"
                      disabled={processingId === event.id}
                      onClick={() => handleDecision(event.id, 'rejected')}
                    >
                      {processingId === event.id ? <FaSpinner className="animate-spin"/> : <FaTimes />}
                      Reject
                    </button>
                    <button
                      className="btn btn-approve"
                      disabled={processingId === event.id}
                      onClick={() => handleDecision(event.id, 'approved')}
                    >
                      {processingId === event.id ? <FaSpinner className="animate-spin"/> : <FaCheck />}
                      Approve
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default PointsReview;